import { UserRoles } from '@/constants/users';
import useCurrentUser from '@/hooks/useCurrentUser';

const isCompanyAdmin = (user?) =>
  UserRoles.USER === (user || useCurrentUser()?.currentUser?.value)?.role;

export default isCompanyAdmin;
